import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weebly': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M425.1 65.8c50.9 0 87.5 35.2 86.9 83.5 0 21.6-1 18.5-77.5 227.2-22.4 60.6-67.8 69.7-92.7 69.7-39.2 0-70-19.5-85.9-54.3-15.9 34.5-46.7 54-85.9 54-25 0-70.4-8.8-92.7-69.4-73-200.2-77.2-204.5-77.2-233.5 0-43.3 38.6-77.2 87.5-77.2 40.2 0 73.3 25.7 83.7 64.3 18.5-58 65.5-64.3 85.3-64.3 19.4 0 66.8 6.3 84.9 64.3 10.4-38.6 43.8-64.3 83.7-64.3zM451.4 180.6c3.5-11.2 7.3-19.4 7.6-27.2 0-22.4-16.2-35.7-38.3-35.7-18.7 0-32 11.8-36.1 29l-44 139.8h-1l-44.7-136.8c-6-20-16.5-32.1-39-32.1s-32.9 12.4-39 32.1l-44.7 136.8h-1l-44-139.8c-4.1-17.3-17.4-29-36.1-29-22.5 0-38.3 13-38.3 29.4 0 10.6 2.5 19.7 7.9 34.5l64.9 175.2c7.9 21.5 21.2 37.2 46.2 37.2 23.1 0 37.1-12.1 44-33.6l39.3-117.4h0.9l39.3 117.4c6.7 21.5 20.6 33.9 44 33.9 25 0 38.3-15.7 46.2-37.2z'
      }
    ]
  }
})
